// extracted by mini-css-extract-plugin
export default {"select":"select_select__-7xYS","error-select":"select_error-select__jsae-"};